import { makeAutoObservable } from "mobx";
import { saveTicketConfirm } from "app/services/PublicService";
import { toast } from "react-toastify";
import { PathModule } from "app/common/LocalConst";
import Config from "app/appConfig";
import history from "history.js";
import { checkPhoneNumber } from "app/common/LocalFunction";

export default class PublicTicketStore {
    //handle print exam registration
    currentTicketComplain = null
    phoneSearchTicket = null;
    
    constructor() {
        makeAutoObservable(this);
    }

    handleSaveTicketComplain = async (obj) => {
        await saveTicketConfirm(obj)
            .then(({ data }) => {
                toast.success("Gửi khiếu nại thành công!");
                this.currentTicketComplain = data;
              ;
            })
            .catch((err) => {
                console.error(err);
                toast.error("Có lỗi xảy ra, vui lòng thử lại!");
            });
    };
    handleSearchPhoneTicketComment = async (obj) => {
        const checkValidatePhone = checkPhoneNumber(obj?.phoneSearch)
        if(checkValidatePhone) {
            toast.warning("Số điện thoại không đúng định dạng!")
            return
        }
        // this.phoneSearchTicket = obj?.phoneSearch || "";
        let url = Config.ROOT_PATH + PathModule.PUBLIC + `/ticket-comment`;
        let search = `?phoneSearch=${obj?.phoneSearch || ""}`;

        history.push({
          pathname: url,
          search,
        });
    };

    
}
